import { Button } from "@shapr3d/frontend-lib";
import classNames from "classnames";

import { useTracker } from "../../hooks/useTracker";
import useTranslation from "../../hooks/useTranslation";

import style from "./DownloadSection.module.css"; // eslint-disable-line

const MacosButton: React.FC<{ downloadURL: string; preferred: boolean }> = ({
  downloadURL,
  preferred,
}) => {
  const tracker = useTracker();
  const { t, m } = useTranslation();
  return (
    <div className={classNames(style.cell, style.mac, preferred && style.preferred)}>
      <Button
        id="download-shapr3d-macos-button"
        className={style.button}
        disabled={!downloadURL}
        variant="primary"
        onClick={() => {
          tracker.trackButtonClick({ elementId: "app-download-button" });
          window.location.assign(downloadURL);
        }}
      >
        {t(m.Download.DownloadFromShapr3D)}
      </Button>
      <div className={style.buttonDescription}>
        <span>{t(m.Download.RequiresMacOS)}</span>
        <div>
          <a
            rel="noreferrer noopener"
            href="https://www.shapr3d.com/compatible-devices#mac"
            target="_blank"
          >
            {t(m.Download.SeeCompatibleMacs)}
          </a>
        </div>
      </div>
    </div>
  );
};

export default MacosButton;
